<template>

  <span ref="wrapElm">
    <span v-if="isHtml == true" v-html="transText"></span>
    <span v-else >{{transText}}</span>
  </span>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name: "trans-text",
    props:{
      i18nKey: {
        type: String,
      },
      default: {
        type: String,
        default: '...'
      },
      isHtml:{
        type: Boolean,
      },
      replaceData:{}, //置換変数がある場合に指定
      adjustLangFontSizes:{} //言語によって文字サイズを調整する際に指定
    },
    mounted(){
      this.elm = $(this.$refs.wrapElm).find("span").first()
      this.$nextTick(function () {
        setTimeout(()=>{
          this.originalFontsize = this.elm.css('font-size').split('px')[0]
          this.procAdjestFont()
        },100)
      })
    },
    watch:{
      transText: function (newVal, oldVal) {
        if(newVal === '...'){ return }
        this.procAdjestFont()
      },
    },
    computed: {
      transText(){
        return this.$te(this.i18nKey)? this.$t(this.i18nKey,this.replaceData): this.default
      }
    },
    methods:{
        procAdjestFont(){
          let i18n = store.get("i18n")
          let adjestFontsize = app.make("_").find(this.adjustLangFontSizes,(val,key)=>{ return i18n === key })
          if(!adjestFontsize){ return }
          $(this.elm).css("fontSize", (Number(this.originalFontsize) * Number(adjestFontsize)))
        },
    },
    data (){
      return {
          elm:null,
          originalFontsize:null,
      }
    },
  }
</script>



// WEBPACK FOOTER //
// TransText.vue?b83faf92